/**
 * ScoreGauge - circular ALTIORA employability gauge (Recharts radial).
 */
import { RadialBar, RadialBarChart, PolarAngleAxis } from "recharts";

export function ScoreGauge({ score = 0, band = "" }) {
  const data = [{ name: "score", value: Math.max(0, Math.min(100, score)) }];
  return (
    <div className="relative flex items-center justify-center">
      <RadialBarChart
        width={220}
        height={220}
        cx="50%"
        cy="50%"
        innerRadius="78%"
        outerRadius="100%"
        barSize={12}
        startAngle={90}
        endAngle={-270}
        data={data}
      >
        <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
        <RadialBar
          background={{ fill: "#EBE8DE" }}
          dataKey="value"
          cornerRadius={2}
          fill="#C5A880"
        />
      </RadialBarChart>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-mono text-5xl font-medium text-[#1F2937] tabular-nums">{score}</div>
        <div className="mt-1 text-[10px] font-mono uppercase tracking-[0.24em] text-[#7A5B14]">
          {band || "—"}
        </div>
      </div>
    </div>
  );
}
